import React, {Component} from 'react';
import {Alert} from "reactstrap"
import SearchHistoryPagination from "./component/SearchHistoryPagination"
import HistoryStatisticItem from "./component/HistoryStatisticItem"
import {_getListHistory} from "../../../../../services/apis/SearchHistoryService"

class SearchHistoryStatisticPage extends Component {
    state = {
        statisticData: [],
        pagination: {
            page: 1,
            pages: 1,
            limit: 100,
            total: 0,
        },
        error: ''
    }

    _delay = null

    componentDidMount() {
        this._fetchStatisticData();

        if (!this._delay) {
            this._delay = setInterval(() => {
                this._fetchStatisticData();
            }, 5000)
        }

    }

    componentWillUnmount() {
        clearInterval(this._delay)
    }

    _fetchStatisticData = () => {
        const {page, limit} = this.state.pagination

        _getListHistory({
            page,
            limit,
        })
            .then(result => {
                if (result.success) {
                    this.setState(({pagination}) => ({
                        statisticData: result.data.docs,
                        pagination: {
                            ...pagination,
                            pages: result.data.pages,
                        }
                    }))
                } else {
                    console.error(result.message)
                }
            })
            .catch(error => {
                console.error(error)
            })
    }

    _handleChangePage = (page) => {
        const {limit} = this.state.pagination
        _getListHistory({
            page,
            limit,
        })
            .then(result => {
                if (result.success) {
                    this.setState(({pagination}) => ({
                        statisticData: result.data.docs,
                        pagination: {
                            ...pagination,
                            page: result.data.page,
                            pages: result.data.pages,
                        }
                    }))
                } else {
                    console.error(result.message)
                }

            })
            .catch(error => {
                console.error(error)
            })
    }

    render() {
        const {error, pagination, statisticData} = this.state;
        return (
            <div className='SearchHistoryStatisticPage'>
                {
                    !!error ? <Alert color="danger">{error}</Alert> : ''
                }
                <h2>Search keyword statistic</h2>
                <div>
                    <div className='row table-row'>
                        <div className='col-3'>Keyword</div>
                        <div className='col-3'>Type</div>
                        <div className='col-3'>User</div>
                        <div className='col-3'>Time</div>
                    </div>
                    {
                        statisticData.map(historyStatisticRecord => {
                            return <HistoryStatisticItem
                                historyStatisticRecord={historyStatisticRecord}
                                key={historyStatisticRecord._id}/>
                        })

                    }
                </div>
                <SearchHistoryPagination paginationInfo={pagination} onChangePage={this._handleChangePage}/>
            </div>
        );
    }
}

export default SearchHistoryStatisticPage;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/searchHistoryStatistic/searchHisoryStatisticPage/SearchHistoryStatisticPage.js